import { atom, selector } from "recoil"

export interface ActionAvatar {
  type:
    | "DOWNLOAD"
    | "ADD"
    | "UPDATE"
    | "RESET"
    | "REMOVE_ALL"
    | "REMOVE"
    | "REMOVE_REPLYS_IDS"
    | "DELETE"
  payload: any
}

export const configAvatarAtom = atom({
  key: "configAvatarAtom",
  default: null
})

export const saveConfigAvatarAtom = atom<string>({
  key: "saveConfigAvatarAtom",
  default: ""
})

export const avatarListConfigsAtom = atom({
  key: "avatarListConfigsAtom",
  default: []
})

export const avatarListConfigsSelector = selector({
  key: "avatarListConfigsSelector",
  get: ({ get }) => {
    return get(avatarListConfigsAtom)
  },
  set: ({ set, get }, action) => {
    const { payload, type } = action as ActionAvatar

    if (type === "DOWNLOAD") {
      set(avatarListConfigsAtom, prev => [...prev, ...payload])
    }

    if (type === "UPDATE") {
      set(avatarListConfigsAtom, prev => {
        const result = prev.map(avatar => {
          if (avatar.id === payload.id) {
            return payload
          }
          return avatar
        })
        return result
      })
    }

    if (type === "DELETE") {
      set(avatarListConfigsAtom, [])
    }
  }
})
